const { valueFormat, GST_RATE } = require('./constants');

const { merge, groupBy } = require('lodash');

const decorateData = data => {
  const defaultValue = '-';
  const products = [];
  if (data) {
    data.forEach(item => {
      item.productVariants.map(i => {
        const product = [
          i.id,
          item.code,
          item.alternateTitle || item.title,
          item.isLive ? 'Yes' : 'No',
          i.barcode,
          i.productColour.colour,
          i.productSize.size,
          item.cost ? parseFloat(item.cost / GST_RATE).toFixed(2) : 0.0,
          i.soldQuantity,
          i.inCheckingQuantity,
          i.soldAmount ? i.soldAmount : '0.00',
          i.quantity,
          valueFormat({ date: true }, item.createdAt),
        ];

        products.push(product);
      });
    });
    return products;
  }
  return [];
};
const processRow = function(row) {
  let finalVal = '';
  for (let j = 0; j < row.length; j++) {
    let innerValue = row[j] === null || typeof row[j] === 'undefined' ? '' : row[j].toString();
    if (row[j] instanceof Date) {
      innerValue = row[j].toLocaleString();
    }
    let result = innerValue.replace(/"/g, '""');
    if (result.search(/("|,|\n)/g) >= 0) result = `"${result}"`;
    if (j > 0) finalVal += ',';
    finalVal += result;
  }
  return `${finalVal}\n`;
};
const transferToCSV = array => {
  let csvFile = '';
  array.forEach(item => {
    csvFile += processRow(item);
  });
  return csvFile;
};
module.exports = {
  decorateData,
  transferToCSV,
};



// WEBPACK FOOTER //
// ./src/components/common/ProductUtil.js